module.exports = __webpack_public_path__ + "img/chufangbanner2.a09bcb58.png";